import { Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { IconConfig } from '../config/icon.config';
import { IconSet } from '../interface/icon.interface';

/**
 * Registers the app's SVG icon sets with Angular Material so the icons are inlined into the DOM.
 * Inlining matters because these icons are stroke based and use `stroke="currentColor"`, which only
 * inherits the surrounding text color when the SVG is part of the document (an <img> would not).
 *
 * Every set in IconConfig.iconSets is registered on app start, so components only need
 * <mat-icon svgIcon="namespace:name"> without injecting this service. Feature modules holding their
 * own icons outside that config can call registerIconSet() instead.
 */
@Injectable({
  providedIn: 'root',
})
export class IconService {
  constructor(
    private _iconRegistry: MatIconRegistry,
    private _sanitizer: DomSanitizer
  ) {
    this.registerConfiguredIconSets();
  }

  /** Registers every icon set declared in IconConfig */
  registerConfiguredIconSets(): void {
    IconConfig.iconSets.forEach((iconSet: IconSet) => {
      this.registerIconSet(iconSet);
    });
  }

  /** Registers a single icon set, making each of its icons available as 'namespace:name' */
  registerIconSet(iconSet: IconSet): void {
    iconSet.icons.forEach((iconName: string) => {
      this._iconRegistry.addSvgIconInNamespace(
        iconSet.namespace,
        iconName,
        this._sanitizer.bypassSecurityTrustResourceUrl(`${iconSet.path}/${iconName}.svg`)
      );
    });
  }
}
